import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRM_BTN } from '../../../../constants/qa'
import { SIZE } from '../../../../constants/size'
import Button from '../../../Button'
import Modal, { Box, Buttons, Header } from '../../../Modal'
import { EpostStatusTimelineContent } from '../EpostStatusTimelineContent'

function EpostStatusTimelineModal({ onCloseModal, ...contentProps }) {
  const { t } = useTranslation()

  return (
    <Modal onClose={onCloseModal}>
      <Box size={SIZE.LARGE}>
        <Header
          text={t('EpostStatusTimeline.ModalTitleKey')}
          onClose={onCloseModal}
        />

        <EpostStatusTimelineContent {...contentProps} />

        <Buttons>
          <Button.Contained
            qaName={QA_NAME_CONFIRM_BTN}
            text={t('Modal.ConfirmBtnKey')}
            onClick={onCloseModal}
          />
        </Buttons>
      </Box>
    </Modal>
  )
}

export default EpostStatusTimelineModal
